import React, {useState} from 'react';
import {
  FlatList,
  Image,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import {useNavigation} from '@react-navigation/native';
import Header from '../../components/Header/Header';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import {Images} from '../../constants/Images';
import {styles} from './styles';
import ModalFilter from '../Home/components/ModalFilter/ModalFilter';
import EquipamentCard from './components/EquipamentCard/EquipamentCard';

const Orders = () => {
  const {goBack} = useNavigation();
  const [filterModal, setFilterModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    setFilterModal(true);
  };

  const orderList = [
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
    {
      name: 'Pedido: 12345678901',
      data: '20/10/2024',
    },
  ];

  return (
    <ScrollView style={styles.scrollView}>
      <Header />
      <View style={styles.containerHeader}>
        <SearchHeader onPress={goBack} title="Equipamentos" />
        <Text style={styles.description}>Informaçôes de equipamentos</Text>
      </View>
      <View style={styles.containerFilter}>
        <Text style={styles.orders}>Equipamentos</Text>
        {/* <TouchableOpacity onPress={handleOpenModal} style={styles.button}>
          <Text style={styles.filter}>Filtrar</Text>
          <Image source={Images.FiltersIcon} />
        </TouchableOpacity> */}
      </View>
      <View style={styles.containerFlat}>
        <EquipamentCard id="1" />
      </View>
      <ModalFilter
        hasBrand
        hasCategory
        hasNews
        hasOrder
        hasSize
        onPress={() => null}
        visible={filterModal}
        onRequestClose={() => setFilterModal(false)}
      />
    </ScrollView>
  );
};

export default Orders;
